
import React from 'react';
import { FileText, Zap, ChevronRight } from 'lucide-react';

const scripts = [
  { name: "Storm Clean Up Script", color: "text-[#1A4D2E] border-[#1A4D2E]/20" },
  { name: "Winter Pruning Special", color: "text-[#4E3629] border-[#4E3629]/20" },
  { name: "Spring Fertilization Email", color: "text-[#FF6B35] border-[#FF6B35]/20" },
];

const Marketplace: React.FC = () => {
  const scrollToForm = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-24 bg-[#0F1419] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center">
        <span className="bg-[#1A4D2E]/20 text-[#1A4D2E] font-black tracking-[0.3em] uppercase mb-6 px-6 py-2 rounded-full text-xs flex items-center gap-2 border border-[#1A4D2E]/30">
          <Zap className="w-4 h-4 text-[#FF6B35]" /> The Plug & Play Library
        </span>
        <h2 className="text-4xl md:text-7xl font-black mb-8 uppercase text-white italic tracking-tighter leading-none">
          "Copy & Paste" Our <br className="hidden md:block" /> Proven Campaigns
        </h2>
        <p className="text-xl text-gray-400 max-w-3xl mx-auto mb-20 font-bold italic">
          Don't know what to write? Don't worry. When you join, you get access to the exact emails, texts, and ads we've used to generate millions for 200+ tree pros.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 w-full max-w-6xl mb-16">
          {scripts.map((script, idx) => (
            <div key={idx} className="bg-[#F4E4C1] rounded-[2rem] p-10 shadow-2xl flex flex-col items-center gap-6 transform rotate-1 hover:rotate-0 transition-all cursor-pointer group border-4 border-transparent hover:border-[#FF6B35]">
              <div className={`w-20 h-20 bg-white rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform ${script.color}`}>
                <FileText className="w-12 h-12" />
              </div>
              <span className="font-black text-[#0F1419] text-xl uppercase italic leading-tight">{script.name}</span>
              <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden border border-[#4E3629]/10">
                <div className="w-3/4 h-full bg-[#1A4D2E] group-hover:bg-[#FF6B35] transition-colors" />
              </div>
              <p className="text-[10px] font-black uppercase tracking-widest text-[#4E3629] opacity-40">Ready for Import</p>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-center gap-4">
          <button 
            onClick={scrollToForm}
            className="bg-[#FF6B35] hover:bg-white hover:text-[#0F1419] text-white px-16 py-8 rounded-2xl text-2xl font-black transition-all shadow-2xl shadow-orange-500/20 uppercase tracking-tighter flex flex-col items-center group cursor-pointer"
          >
            <span className="flex items-center gap-3">GET THE SCRIPTS NOW <ChevronRight className="w-7 h-7 group-hover:translate-x-1 transition-transform" /></span>
            <span className="block text-xs font-black opacity-70 mt-2 tracking-[0.2em] uppercase">Included in your white-glove setup</span>
          </button>
          <p className="text-[#FF6B35] font-black uppercase text-sm tracking-widest animate-pulse">
            ONLY 7 SPOTS LEFT THIS MONTH
          </p>
        </div>
      </div>
    </section>
  );
};

export default Marketplace;
